import { Outlet, Navigate } from 'react-router-dom';
import UserService from 'services/userService';

export default function PrivateRoute({ allowedRoles }) {
  const user = UserService.getCurrentUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
